const gtmStartRegistration = () => {
    const path = window.location.pathname
    dataLayer.push({
        event: 'registration',
        step: 'start_button',
        source_page: path,
        _clear: true,
    })
}

export default gtmStartRegistration
